module.exports = __webpack_public_path__ + "pn.250c320b.svg";